export default __webpack_public_path__ + "static/media/carousel001.e84b2709.jpg";